import { apiClient } from './client';

export type AddressMatchCriteria = {
  address1: string;
  city: string;
  zip: string;
  address2?: string | null;
  state?: string | null;
  country?: string | null;
  country_code?: string | null;
};

export type NewDestinationAddress = {
  address1: string;
  address2?: string | null;
  city: string;
  state?: string | null;
  zip: string;
  country: string;
  country_code: string;
  name?: string | null;
  company?: string | null;
  phone?: string | null;
};

export type AddressSnapshot = {
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  country: string | null;
  country_code: string | null;
};

export function formatAddressSnapshot (address: AddressSnapshot): string {
  return [
    address.address1,
    address.address2,
    address.city,
    address.state,
    address.zip,
    address.country,
    address.country_code,
  ]
    .filter((part) => part != null && String(part).trim() !== '')
    .join(', ');
}

export type MatchedDestination = {
  id: number;
  name: string;
  current_address: AddressSnapshot;
  proposed_address: AddressSnapshot;
};

export type PreviewRow = {
  shop_id: number;
  shop_name: string | null;
  status: 'match' | 'skip' | 'multi_match' | 'linked_location' | 'return_policy_country';
  message: string | null;
  matched_destinations: MatchedDestination[];
};

export type ApplyRow = {
  shop_id: number;
  destination_id: number;
  status: 'updated' | 'failed';
  message: string | null;
};

export function previewBulkDestinationAddressUpdate (payload: {
  shop_ids: number[];
  match: AddressMatchCriteria;
  new_address: NewDestinationAddress;
}) {
  return apiClient.post<{ rows: PreviewRow[] }>(
    '/destinations/bulk-address-update/preview',
    payload,
  );
}

export const APPLY_CHUNK_SIZE = 25;

export function chunkList<T> (items: readonly T[], size: number): T[][] {
  const chunks: T[][] = [];
  for (let offset = 0; offset < items.length; offset += size) {
    chunks.push(items.slice(offset, offset + size));
  }
  return chunks;
}

export function applyBulkDestinationAddressUpdate (payload: {
  updates: Array<{ shop_id: number; destination_id: number }>;
  match: AddressMatchCriteria;
  new_address: NewDestinationAddress;
}) {
  return apiClient.post<{ rows: ApplyRow[] }>(
    '/destinations/bulk-address-update/apply',
    payload,
  );
}
